export const ChevronDown = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.6989 7.45029L20.699 7.45019L20.6949 7.4471C20.3529 7.18497 19.8613 7.21927 19.5596 7.5398L12.1781 15.3824L4.79756 7.5398L4.72474 7.60833L4.79756 7.5398C4.47582 7.19795 3.93788 7.18165 3.59603 7.50339C3.25418 7.82513 3.23788 8.36307 3.55962 8.70492L11.1955 16.8181C11.7065 17.361 12.5609 17.3869 13.1038 16.8759L13.1046 16.8752L13.1253 16.8552L13.1254 16.8552L13.1283 16.8521L20.7976 8.70492L20.7247 8.63638L20.7976 8.70492C21.1193 8.36307 21.103 7.82513 20.7611 7.50339L20.7612 7.5033L20.7574 7.50003L20.6989 7.45029Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
    />
  </svg>
);
